import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../../shared/icons';
import MyButton from '../../../../UI/myButton/MyButton';
import { formatPrice } from '../../../../../../utils/FormatPrice';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleOpenDialogForm,
  handleOpenDokumenta,
  isLoading,
}) => {
  const shouldHideColumns = localStorage.sa === 'true';
  const allColumns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          handleOpenDokumenta={() => handleOpenDokumenta(e.row)}
          getEditData={() => handleOpenDialogForm(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'nazivDela', headerName: 'Naziv dela', width: 300 },
    { field: 'kolicina', headerName: 'Količina', width: 80 },
    {
      field: 'cena',
      headerName: 'Cena',
      width: 120,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold' }}>{formatPrice(params.value)}</span>
      ),
    },
    {
      field: 'nabavnaCena',
      headerName: 'Nabavna cena',
      width: 120,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold' }}>{formatPrice(params.value)}</span>
      ),
    },
    {
      field: 'cenaKolicina',
      headerName: 'Ukupno',
      width: 120,
      align: 'right',
      renderCell: (params) => (
        <span style={{ fontWeight: 'bold' }}>{formatPrice(params.value)}</span>
      ),
    },

    { field: 'napomena', headerName: 'Napomena', width: 300 },
  ];
  const columns = allColumns.filter((column) => {
    if (!shouldHideColumns) {
      // Sakrivamo kolone 'brutoCenaZaposlenog' i 'cena' kada je shouldHideColumns false
      if (column.field === 'nabavnaCena' || column.field === 'cena') {
        return false;
      }
    }

    return true;
  });
  return (
    <div style={{ height: '52vh', width: '99%' }}>
      <MyButton
        label="Novi unos"
        style={{ marginBottom: '5px' }}
        onClick={() => handleOpenDialogForm({})}
      />
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleOpenDialogForm: PropTypes.func.isRequired,
};

export default GridProvider;
